import React, { useState, useEffect } from 'react'
import {
  Modal,
  Button,
  Form,
  FormGroup,
  FormLabel,
  FormSelect,
} from 'react-bootstrap'
import toast from 'react-hot-toast'
import ApiEndpoints, {BASE_URL, BASE_URL_Upload} from './commonComponents/ApiEndpoints'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useAuth } from './AuthContext'

const EditStudentModal = ({ show, handleClose, studentData }) => {
  const {token} = useAuth()
  const [updatedStudent, setUpdatedStudent] = useState({
    name: '',
    dob: '',
    // age: '',
    gender: '',
    father_name: '',
    mother_name: '',
    admission_date: '',
    admission_number: '',
    course_id: '',
    class_id: '',
    roll_number: '',
    phone: '',
    whatsapp_number: '',
    parents_number: '',
    email: '',
    address: '',
    institute_id: '',
    id_proof_number: '',
    id_proof_type: '',
  })

  const navigate = useNavigate()
  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [institutes, setInstitutes] = useState([])
  const [studentCount, setStudentCount] = useState(null)
  const [countColor, setCountColor] = useState('') // Add color for the response
  const [studentImage, setStudentImage] = useState(null)

  const [selectedNewCourse, setSelectedNewCourse] = useState([])
  useEffect(() => {
    ApiEndpoints.getAllClasses().then((res) => setClasses(res.data.data))
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
    ApiEndpoints.getAllInstitutes().then((res) => setInstitutes(res.data.data))
  }, [])

  const [courseTouched, setCourseTouched] = useState(false)

  const handleCourseChange = (e) => {
    const courseId = e.target.value
    setUpdatedStudent((prev) => ({ ...prev, course_id: courseId }))

    console.log('Selected course Id:', courseId)
    setCourseTouched(true)
    setSelectedNewCourse(courseId)
    setStudentCount(null)
    console.log('Cleared Classes')

    if (courseId) {
      ApiEndpoints.getAllClassesByCourseId(courseId)
        .then((res) => {
          const { data } = res
          if (data.status === false || !data.data?.length) {
            // toast.error('No classes found for this course.')
            setClasses([])
            setStudentCount(null)
          } else {
            setClasses(data.data)
            // setUpdatedStudent(data.data)
          }
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            // toast.error('No classes found for this course.')
          } else {
            console.error('Error fetching classes:', error)
            // toast.error('Something went wrong while fetching classes.')
          }
          setClasses([])
        })
    }
  }

  useEffect(() => {
    if (studentData) {
      setSelectedNewCourse(studentData.course_id)
      setUpdatedStudent({
        class_name: studentData.class_name || '',
        name: studentData.name || '',
        dob: studentData.dob || '',
        // age: '',
        gender: studentData.gender || '',
        father_name: studentData.father_name || '',
        mother_name: studentData.mother_name || '',
        admission_date: studentData.admission_date || '',
        admission_number: studentData.admission_number || '',
        course_id: studentData.course_id || '',
        class_id: studentData.class_id || '',
        roll_number: studentData.roll_number || '',
        phone: studentData.phone || '',
        whatsapp_number: studentData.whatsapp_number || '',
        parents_number: studentData.parents_number || '',
        email: studentData.email || '',
        address: studentData.address || '',
        institute_id: studentData.institute_id || '',
        id_proof_number: studentData.id_proof_number || '',
        id_proof_type: studentData.id_proof_type || '',
      })
    }
  }, [studentData])
  const handleClassChange = (e) => {
    const classId = e.target.value
    setUpdatedStudent((prev) => ({ ...prev, class_id: classId }))

    // Clear previous student count
    setStudentCount(null)
    setCountColor('')

    if (classId) {
      // Call the API to get the student count for the selected class
      fetch(
        BASE_URL+`/get/class/student/count?class_id=${classId}`,{
        headers :
          {
          Authorization: `Bearer ${token}`
        }
      } 
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data?.status &&
            data?.data?.current !== undefined &&
            data?.data?.maximum_limit !== undefined
          ) {
            const current = data.data.current === null ? 0 : data.data.current // Treat null as 0
            const maximum_limit = parseInt(data.data.maximum_limit, 10) // Parse maximum_limit as a number
            setStudentCount({ current, maximum_limit }) // Set the state with correct property names
            setCountColor('green') // Example color for success
          } else {
            setStudentCount('No data available')
            setCountColor('red') // Example color for no data
          }
        })
        .catch((error) => {
          console.error('Error fetching student count:', error)
          setStudentCount('Error fetching data')
          setCountColor('red') // Example color for error
        })
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setUpdatedStudent((prev) => ({ ...prev, [name]: value }))
  }

  const handleSaveChanges = async (e) => {
    e.preventDefault()
    try {
      let imageUrl = null
      if (studentImage) {
        if (studentImage.size > 2 * 1024 * 1024) {
          toast.error('Image size should not exceed 2MB.')
          return
        }
        const formData = new FormData()
        formData.append('image', studentImage)
        formData.append('folder', 'student')
        for (let [key, value] of formData.entries()) {
          console.log(`${key}:`, value)
        }
        const imageResponse = await axios.post(
          BASE_URL+'/upload-image',
          formData,
        )
        imageUrl = BASE_URL_Upload + `/${imageResponse.data.path}`
        console.log('IMGURL', imageUrl)
      }
      const updatedData = {
        ...updatedStudent,
        student_image: imageUrl,
      }
      console.log('Sending data: ', updatedData)

      const response = await ApiEndpoints.editStudent(
        studentData.id,
        updatedData,
      )
      toast.success(response.data.message)
      handleClose()
    } catch (error) {
      toast.error(error.response?.data?.message)
    }
  }

  const handleNavigateToCreateClass = () => {
    navigate('/AddClass')
  }
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton 
        closeVariant="white"
        className="bg-warning text-dark">
        <Modal.Title>Edit Student Detail</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* Personal Details */}

          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={updatedStudent.name}
              onChange={handleInputChange}
              placeholder="Enter Name"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Date of Birth</Form.Label>
            <Form.Control
              type="date"
              name="dob"
              value={updatedStudent.dob}
              onChange={handleInputChange}
            />
          </Form.Group>

          {/* <Form.Group className="mb-3">
              <Form.Label>Age</Form.Label>
              <Form.Control
                type="text"
                name="age"
                value={updatedStudent.age}
                disabled
              />
            </Form.Group> */}

          <Form.Group className="mb-3">
            <Form.Label>Gender</Form.Label>
            <Form.Select
              name="gender"
              value={updatedStudent.gender}
              onChange={handleInputChange}
            >
              <option value="">Select</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>ID Type *</Form.Label>
            <Form.Select
              name="id_proof_type"
              value={updatedStudent.id_proof_type}
              onChange={handleInputChange}
            >
              <option value="">Select</option>
              <option value="aadhar card">Aadhaar</option>
              <option value="voter card">Voter ID</option>
              <option value="license">License</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>ID Proof Number</Form.Label>
            <Form.Control
              type="number"
              name="id_proof_number"
              value={updatedStudent.id_proof_number}
              onChange={handleInputChange}
              placeholder="Enter Roll Number"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Father's Name</Form.Label>
            <Form.Control
              type="text"
              name="father_name"
              value={updatedStudent.father_name}
              onChange={handleInputChange}
              placeholder="Enter Father's Name"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Mother's Name</Form.Label>
            <Form.Control
              type="text"
              name="mother_name"
              value={updatedStudent.mother_name}
              onChange={handleInputChange}
              placeholder="Enter Mother's Name"
            />
          </Form.Group>

          {/* Admission Details */}

          <Form.Group className="mb-3">
            <Form.Label>Admission Date</Form.Label>
            <Form.Control
              type="date"
              name="admission_date"
              value={updatedStudent.admission_date}
              onChange={handleInputChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Admission Number</Form.Label>
            <Form.Control
              type="text"
              name="admission_number"
              value={updatedStudent.admission_number}
              onChange={handleInputChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Course *</Form.Label>
            <Form.Select
              name="course_id"
              value={selectedNewCourse}
              onChange={handleCourseChange}
              disabled
            >
              <option value="">Select Course</option>
              {courses.map((course) => (
                <option key={course.id} value={course.id}>
                  {course.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {classes.length === 0 && selectedNewCourse && (
            <p style={{ color: 'red', letterSpacing: '1px' }}>
              The selected course has no class. Please{' '}
              <span
                className="blinking-link"
                onClick={handleNavigateToCreateClass}
              >
                click here
              </span>{' '}
              to create new class.
            </p>
          )}

          <Form.Group className="mb-3">
            <Form.Label>Class *</Form.Label>
            <Form.Select
              name="class_id"
              value={updatedStudent.class_id}
              onChange={handleClassChange}
              disabled={!courseTouched || classes.length === 0}
            >
              <option value="">Select Class</option>
              {classes.map((clas) => (
                <option key={clas.id} value={clas.id}>
                  {clas.class_name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {studentCount !== null && studentCount !== 'No data available' && (
            <div
              style={{
                color: countColor,
                marginBottom: '5px',
                fontWeight: 'bold',
                letterSpacing: '1px',
              }}
            >
              {studentCount.current === null
                ? `There are still ${studentCount.maximum_limit} seats available in this class.`
                : studentCount.current === studentCount.maximum_limit
                ? 'There are no more seats available in this class.'
                : `There are ${
                    studentCount.maximum_limit - studentCount.current
                  } seats left in this class.`}
            </div>
          )}

          <FormGroup className="mb-3">
            <FormLabel>Institute</FormLabel>
            <FormSelect
              name="institute_id"
              value={updatedStudent.institute_id}
              onChange={handleInputChange}
              disabled
            >
              <option value="">Select Institute</option>
              {institutes.map((institute) => (
                <option key={institute.id} value={institute.institute_id}>
                  {institute.name}
                </option>
              ))}
            </FormSelect>
          </FormGroup>

          {/* roll number */}

          {/* <Form.Group className="mb-3">
            <Form.Label>Roll Number</Form.Label>
            <Form.Control
              type="number"
              name="roll_number"
              value={updatedStudent.roll_number}
              onChange={handleInputChange}
              placeholder="Enter Roll Number"
            />
          </Form.Group> */}

          {/* Contact Details */}

          <Form.Group className="mb-3">
            <Form.Label>Phone</Form.Label>
            <Form.Control
              type="text"
              name="phone"
              value={updatedStudent.phone}
              onChange={handleInputChange}
              placeholder="Enter Phone Number"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>WhatsApp Number</Form.Label>
            <Form.Control
              type="text"
              name="whatsapp_number"
              value={updatedStudent.whatsapp_number}
              onChange={handleInputChange}
              placeholder="Enter WhatsApp Number"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Parent's Phone</Form.Label>
            <Form.Control
              type="text"
              name="parents_number"
              value={updatedStudent.parents_number}
              onChange={handleInputChange}
              placeholder="Enter Parent's Phone Number"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={updatedStudent.email}
              onChange={handleInputChange}
              placeholder="Enter Email"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Address</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="address"
              value={updatedStudent.address}
              onChange={handleInputChange}
              placeholder="Enter Address"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Student Image (PNG/JPG/JPEG)</Form.Label>

            <div className="d-flex align-items-center gap-3 mt-2 mb-2">
              <Form.Control
                type="file"
                accept="student_image/png, student_image/jpeg, student_image/jpg"
                onChange={(e) => setStudentImage(e.target.files[0])}
                style={{ maxWidth: '700px' }}
              />
              {studentImage && (
                <img
                  src={URL.createObjectURL(studentImage)}
                  alt="Preview"
                  style={{
                    width: 100,
                    height: 100,
                    objectFit: 'cover',
                    borderRadius: 8,
                    border: '1px solid #ccc',
                  }}
                />
              )}
            </div>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="warning" onClick={handleSaveChanges}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EditStudentModal
